module.exports = __webpack_public_path__ + "media/images/case-studies/bonnie-beef-growers-38e0bb0274997baeaa3e2be468996581.png";